//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ImagePreview } from "vant";
export default {
  props: ["viewDataList", "dataConfig"],
  data() {
    return {
      show: true,
      curDataTimeItem: {},
      curSelectItem: {}
    };
  },
  created() {},
  methods: {
    onImageClick(controlItem) {
      if (!controlItem.ControlValue) return;
      if (controlItem.ControlValue.length == 0) return;

      ImagePreview({
        images: controlItem.ControlValue,
        startPosition: 0
      });
    },

    onImageDeleteClick() {
      return false;
    },
    uploadBefore(controlItem) {},

    file_change(e, controlItem) {
      var imgFile = e.target.files[0];
      if (imgFile) {
        this.$msg.loading("上传中");
        var fr = new FileReader();
        fr.readAsDataURL(imgFile);
        fr.onload = () => {
          var base_url = fr.result
            .replace("data:image/png;base64,", "")
            .replace("data:image/jpg;base64,", "")
            .replace("data:image/jpeg;base64,", "");
          var formData = new FormData();
          formData.append("url", base_url);
          console.log("base_url", base_url);
          var url = "File/UploadStreamFile";

          this.$http({
            url: url,
            method: "post",
            headers: {
              "Content-Type": "multipart/form-data"
            },
            data: formData
          })
            .then(res => {
              this.$msg.hideLoading();
              if (res.data.state == 1) {
                var imgSrc = res.data.data.src;
                controlItem.ControlValue = imgSrc;
              } else {
                this.$msg.alert(res.data.msg);
              }
            })
            .catch(err => {
              this.$msg.hideLoading();
            });
        };
      }
    },

    clearUploadImg(controlItem) {
      controlItem.ControlValue = "";
      var ref = "ref_" + controlItem.OpenId;
      this.$refs[ref].value = null;
    },
    selectClick(controlItem) {
      controlItem.show = true;
      this.curSelectItem = controlItem;
    },
    selectConfirm(res) {
      this.curSelectItem.value = res;
      this.$emit("selectCb", res);
    },

    getSubmitData(){
      return this.$getSubmitData();
    },

    $getSubmitData() {
      // 将表单数据处理后返回
      let submitData = {};
      this.viewDataList.forEach(groupItem => {
        groupItem.ControlsList.forEach(controlItem => {
          if (controlItem.ControlType == "textareaBtn" && controlItem.isObj) {
            submitData[controlItem.ControlId] = {
              value: controlItem.ControlValue,
              label: controlItem.LabelName
            };
          } else if (controlItem.ControlType == "interval") {
            if (controlItem.ControlValue.min > controlItem.ControlValue.max) {
              this.$msg.warn("最小值不得超过最大值");
            }
            submitData[controlItem.ControlId] = controlItem.ControlValue;
          } else if (controlItem.ControlType == "InputRange") {
            submitData[controlItem.ControlId.Start] =
              controlItem.ControlValue.Start;
            submitData[controlItem.ControlId.End] =
              controlItem.ControlValue.End;
          } else {
            submitData[controlItem.ControlId] = controlItem.ControlValue;
          }
        });
      });

      return submitData;
    }
  }
};
